// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import Field from '../Field';

class KeywordField extends Component {
  constructor(props) {
    super(props);

    this.handleUpdateField = this.handleUpdateField.bind(this);
  }

  handleUpdateField(event) {
    this.props.handleUpdateFilter('keyword', event.target.value);
  }
  
  render() {
    const { currentValue } = this.props
    
    return ( 
      <Field customClasses="filter-v2__text-field" iconLeft="search">
        <input
          className="filter-v2__input"
          name="keyword"
          type="text"
          placeholder="Busca"
          value={currentValue}
          onChange={this.handleUpdateField}
        />
      </Field>
    );
  }
}

KeywordField.defaultProps = {
  options: [],
  handleUpdateFilter: () => {},
  currentValue: '',
};

KeywordField.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.objectOf({
      title: PropTypes.string,
    })
  ),
  handleUpdateFilter: PropTypes.func,
  currentValue: PropTypes.string,
};

export default KeywordField;
